import { gql } from 'apollo-angular';

export const GET_NOTIFICATIONS = gql`
  query GetNotifications($filtering: NotificationFilterInput) {
    getNotifications(filtering: $filtering) {
      response {
        id
        status
        code
        message
        errors {
          kind
          message
          field
          code
        }
      }
      page {
        number
        hasNextPage
        hasPreviousPage
        nextPageNumber
        previousPageNumber
        numberOfPages
        totalElements
        pages
      }
      data {
        id
        uniqueId
        title
        body
        notificationType
        actionUrl
        isRead
        readAt
        createdAt
      }
    }
  }
`;

export const GET_UNREAD_NOTIFICATION_COUNT = gql`
  query GetUnreadNotificationCount {
    getUnreadNotificationCount {
      response {
        id
        status
        code
        message
        errors {
          kind
          message
          field
          code
        }
      }
      data
    }
  }
`;

export const MARK_NOTIFICATION_AS_READ = gql`
  mutation MarkNotificationAsRead($uniqueId: String!) {
    markNotificationRead(uniqueId: $uniqueId) {
      response {
        status
        code
        message
      }
    }
  }
`;

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation MarkAllNotificationsAsRead {
    markAllNotificationsRead {
      response {
        status
        code
        message
      }
    }
  }
`;
